module.exports = __webpack_public_path__ + "public/img/9.46c23d01.png";